import { render, staticRenderFns } from "./activityEditSemesterBatches.html?vue&type=template&id=d0bc78ac&scoped=true&"
import script from "./activityEditSemesterBatches.vue?vue&type=script&lang=js&"
export * from "./activityEditSemesterBatches.vue?vue&type=script&lang=js&"
import style0 from "./activityEditSemesterBatches.css?vue&type=style&index=0&id=d0bc78ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bc78ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VDataTable,VRow,VTextField,VTreeview})
